/* eslint-disable */
export default {
  forward: 'Inoltra',
  reply: 'Risposta',
  ignore: 'Ignora',
  toVoicemail: 'Alla segreteria telefonica',
  answer: 'Rispondi',
  answerAndEnd: 'Rispondi e termina',
  answerAndHold: 'Rispondi e attesa',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
